module.exports = __webpack_public_path__ + "img/res6.9b84f4a0.png";